module.exports = __webpack_public_path__ + "img/Honig-aus-2021-620.02310ab8.jpg";